var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg1",style:(_vm.style)},[_c('div',{staticClass:"img"})])}
var staticRenderFns = []

export { render, staticRenderFns }